/**
 * Push to dataLayer safely.
 * @param {Record<string, any>} payload
 */
function pushToDataLayer(payload) {
	try {
		if (typeof window === "undefined") return;
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(payload);
	} catch (e) {
		console.log("ga4 push error", e);
	}
}

/**
 * GA4にログインイベントを送信
 *
 * @param {{ User_id?: string|number, Channel?: string }} params
 */
export function sendLoginEvent(params = {}) {
	const { User_id, Channel } = params;

	console.log("[GA LOGIN] sendLoginEvent called:", {
    User_id,
    Channel,
  	});

	pushToDataLayer({
		event: "login",
		User_id: User_id ?? undefined,
		Channel: Channel ?? undefined
	});
}

export default {
	sendLoginEvent
};
